<script>
export default {
  name: "GlyphSortButtonGroup",
  data() {
    return {
      showScoreFilter: false,
    };
  },
  methods: {
    update() {
      this.showScoreFilter = EffarigUnlock.glyphFilter.isUnlocked;
    },
    sortByLevel() {
      Glyphs.sortByLevel();
    },
    sortByPower() {
      Glyphs.sortByPower();
    },
    sortByScore() {
      Glyphs.sortByScore();
    },
    sortByEffect() {
      Glyphs.sortByEffect();
    },
    collapseEmpty() {
      Glyphs.collapseEmptySlots();
    }
  }
};
</script>

<template>
  <div class="o-glyph-inventory-management-group">
    <div class="l-glyph-sacrifice-options__header">
      Сортировать Глифы:
    </div>
    <button
      class="c-glyph-inventory-option"
      @click="sortByLevel"
    >
      Сортировать по уровню
      <div class="c-glyph-inventory-option__tooltip">
        Распределяет по убыванию уровня Глифа
      </div>
    </button>
    <button
      class="c-glyph-inventory-option"
      @click="sortByPower"
    >
      Сортировать по мощности
      <div class="c-glyph-inventory-option__tooltip">
        Расставляет по убыванию уровня×редкость
      </div>
    </button>
    <button
      class="c-glyph-inventory-option"
      @click="sortByEffect"
    >
      Сортировать по эффектам
      <div class="c-glyph-inventory-option__tooltip">
        Группирует Глифы вместе, основываясь на их эффектах
      </div>
    </button>
    <button
      v-if="showScoreFilter"
      class="c-glyph-inventory-option"
      @click="sortByScore"
    >
      Сортировать по счёту
      <div class="c-glyph-inventory-option__tooltip">
        Расставляет по убыванию счёта Фильтра Глифов
      </div>
    </button>
    <button
      class="c-glyph-inventory-option"
      @click="collapseEmpty"
    >
      Убрать пустое место
      <div class="c-glyph-inventory-option__tooltip">
        Сдвигает все Глифы к наиболее ранним пустым слотам
      </div>
    </button>
  </div>
</template>

<style scoped>

</style>
